module.exports = __webpack_public_path__ + "static/img/plug6.0d751b9a.webp";